import join from 'url-join';
import { asyncAction, http } from '../util';
import { getBillableAccountDepartments } from '../user/actions';

const api2 = join(import.meta.env.VITE_API2_URL, 'v1');

export const fetchGamedayAccount = asyncAction({
  baseName: 'GET_GAMEDAY_ACCOUNT',
  action: action => ({ accountNumber }) => dispatch => {
    dispatch(action.start({ accountNumber }));

    return http
      .get(`${api2}/accounts/${accountNumber}`)
      .then(({ data: response }) => {
        if (response?.billable?.accountNumber) {
          dispatch(getBillableAccountDepartments({ accountNumber: response.billable.accountNumber }));
        }

        return dispatch(action.success({ response }));
      })
      .catch(error => dispatch(action.error({ error })));
  }
});
